import { 
    FETCH_LANGUAGE,
    FETCH_LANGUAGE_SUCCESS,
    FETCH_LANGUAGE_FAILED,
    EDIT_LANGUAGE
  } from "../store/types";
  
  // defaultLanguage arranca como objeto vacío en vez de null para que cualquier
  // `state.languagedata.defaultLanguage.<key>` durante el cold start devuelva
  // undefined en lugar de crashear con "Cannot read property of null".
  // Antes el cold start de la app de socio explotaba con
  //   TypeError: Cannot read property 'auth_error' of null
  // porque `fetchUser` corría antes de que `fetchLanguages` resolviera.
  export const INITIAL_STATE = {
    langlist:null,
    defaultLanguage:{},
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const languagereducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_LANGUAGE:
        return {
          ...state,
          loading:true
        };
      case FETCH_LANGUAGE_SUCCESS:
        return {
          ...state,
          ...action.payload,
          loading:false
        };
      case FETCH_LANGUAGE_FAILED:
        return {
          ...state,
          langlist:null,
          defaultLanguage:{},   // mantener `{}` para no romper accesos posteriores
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case EDIT_LANGUAGE:
        return state;
      default:
        return state;
    }
  };